module.exports = __webpack_public_path__ + "static/img/ch.9c26f60a.svg";